/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Invite_ClosedInputs */

const en_adm_err_invite_closed = /** @type {(inputs: Adm_Err_Invite_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation was already accepted or revoked.`)
};

const de_adm_err_invite_closed = /** @type {(inputs: Adm_Err_Invite_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einladung wurde bereits angenommen oder widerrufen.`)
};

/**
* | output |
* | --- |
* | "This invitation was already accepted or revoked." |
*
* @param {Adm_Err_Invite_ClosedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_invite_closed = /** @type {((inputs?: Adm_Err_Invite_ClosedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Invite_ClosedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_invite_closed(inputs)
	return en_adm_err_invite_closed(inputs)
});